import EditBillRateHistoryEntryForm from './EditBillRateHistoryEntryForm';

export default EditBillRateHistoryEntryForm;
